module.exports = __webpack_public_path__ + "img/my-account-mobile-fr.32391d71.jpg";